import { render, staticRenderFns } from "./searchWard.vue?vue&type=template&id=26257184&scoped=true&"
import script from "./searchWard.vue?vue&type=script&lang=js&"
export * from "./searchWard.vue?vue&type=script&lang=js&"
import style0 from "./searchWard.vue?vue&type=style&index=0&id=26257184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26257184",
  null
  
)

export default component.exports